import { useEffect } from 'react'
import { useWorkerDataProcessSelector, useWorkerMeasurementDataProcessSelector } from '../store/selectors/workersSelector'
import { useExperimentApi } from '../store/api/hooks/experimentApiHook'
import toast from 'react-hot-toast'
import { ACTIONS, URLS } from '../_config'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import Button from '../elements/button'
import Text from '../elements/Typo/Text'

const Workers: React.FC = () => {
    const { t } = useTranslation()
    const experimentAPI = useExperimentApi()
    const dataProcessExperimentID: any = useWorkerDataProcessSelector()
    const measurementDataProcessExperimentID: any = useWorkerMeasurementDataProcessSelector()
    const dispatch = useDispatch()
    const onExperimentFileUpload = () => {
        toast(
            (toastInstance) => (
                <div className="flex flex-col gap-3 items-center justify-center">
                    <Text size="lg">{t('Your data file procced completed')}</Text>
                    <Button
                        theme="secondary"
                        size="xxs"
                        onClick={() => {
                            ;(globalThis as any).location.href = URLS.CREATE_EXPERIMENT(dataProcessExperimentID)
                            toast.dismiss(toastInstance.id)
                        }}
                    >
                        {t('Continue')}
                    </Button>
                </div>
            ),
            { duration: 20000 },
        )

        dispatch({
            type: ACTIONS.WORKERS.DATA_PROCESSING,
            payload: null,
        })
    }

    const checkExperimentFileUpload = () => {
        experimentAPI.getExperimentDetailsWatch(
            { literal: dataProcessExperimentID, use_orm: true },
            (resp: any) => {
                if (resp?.data_mappings?.user_created_table_name) {
                    onExperimentFileUpload()
                } else {
                    setTimeout(checkExperimentFileUpload, 3000)
                }
            },
            (error: any) => {
                //----
            },
        )
    }
    const onMeasurmentfileUpload = () => {
        toast(
            (toastInstance) => (
                <div className="flex flex-col gap-3 items-center justify-center">
                    <Text size="lg">{t('Your data file procced completed')}</Text>
                    <Button
                        theme="secondary"
                        size="xxs"
                        onClick={() => {
                            ;(globalThis as any).location.href = URLS.MEASUREMENT(measurementDataProcessExperimentID, 'data')
                            toast.dismiss(toastInstance.id)
                        }}
                    >
                        {t('Continue')}
                    </Button>
                </div>
            ),
            { duration: 20000 },
        )

        dispatch({
            type: ACTIONS.WORKERS.MEASUREMENT_DATA_PROCESSING,
            payload: null,
        })
    }
    const checkExperimentMeasurementFileUpload = () => {
        experimentAPI.getExperimentDetailsWatch(
            { literal: measurementDataProcessExperimentID, use_orm: true },
            (resp: any) => {
                if (resp?.data_mappings?.user_created_measurement_table_name) {
                    onMeasurmentfileUpload()
                } else {
                    setTimeout(checkExperimentMeasurementFileUpload, 3000)
                }
            },
            (error: any) => {
                //----
            },
        )
    }

    useEffect(() => {
        if (dataProcessExperimentID) {
            checkExperimentFileUpload()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataProcessExperimentID])

    useEffect(() => {
        if (measurementDataProcessExperimentID) {
            checkExperimentMeasurementFileUpload()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [measurementDataProcessExperimentID])

    return null
}

export default Workers
